<template>
  <div class="chart chart-move">
    <!-- <v-layout v-if="editMode" class="chart-tool">
      <v-flex  row>
        <v-spacer></v-spacer>
        <v-btn flat icon dark slot="activator" v-scroll-to="'#down'" @click="$emit('duplicate-chart', slice)">
          <v-tooltip bottom>
            <v-icon small slot="activator">file_copy</v-icon>
            <span>Duplicate Chart</span>
          </v-tooltip>
        </v-btn>
        <v-btn flat icon dark slot="activator" @click="$emit('edit-chart', chartId)">
          <v-tooltip bottom>
            <v-icon small slot="activator">build</v-icon>
            <span>Edit Chart</span>
          </v-tooltip>
        </v-btn>
        <v-btn flat icon dark slot="activator" @click="$emit('deleteChart', chartId)">
          <v-tooltip bottom>
            <v-icon small slot="activator">remove_circle_outline</v-icon>
            <span>Delete Chart</span>
          </v-tooltip>
        </v-btn>
      </v-flex>
    </v-layout> -->
    <v-layout v-if="editMode" class="chart-tool" >
      <v-spacer />
      <v-menu
        transition="slide-y-transition"
        offset-y
        :close-on-content-click="false"
      >
          <template v-slot:activator="{ on }">
            <v-btn dark icon v-on="on" style="outline: none;" @click="action">
              <v-icon>more_vert</v-icon>
            </v-btn>
          </template>

          <v-list>
            <v-list-tile @click="$emit('duplicate-chart', slice)" v-scroll-to="'#down'">
              <v-icon size="16" style="color: #757575;">file_copy</v-icon>
              <v-list-tile-title style=" margin-left: 5px; color: #757575;">Duplicate</v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="$emit('edit-chart', chartId)" >
              <v-icon size="16" style="color: #757575;">build</v-icon>
              <v-list-tile-title  style=" margin-left: 5px; color: #757575;">Edit</v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="$emit('deleteChart', chartId)" >
              <v-icon size="16" style="color: #757575;">remove_circle_outline</v-icon>
              <v-list-tile-title  style=" margin-left: 5px; color: #757575;">Delete</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
    </v-layout>
    <v-layout v-else-if="previewMode === true" mx-0 my-1>
    </v-layout>
    <v-layout v-else class="extand-chart">
      <v-flex row >
        <v-spacer></v-spacer>
        <v-btn
          flat
          icon
          dark
          style="outline: none;"
          slot="activator"
          class="btn-zoom-chart"
          @click="$emit('full-chart', chartId)"
        >
          <v-tooltip bottom>
            <v-icon slot="activator">zoom_in</v-icon>
            <span>Full Chart</span>
          </v-tooltip>
        </v-btn>
      </v-flex>
    </v-layout>
    <p v-if="host">
      <font size="3" color="#f0ffff" style="margin-top: 50px;">{{host}}</font>
      <!-- <sup>
        <font size="2" color="#C17F3F" style="margin-top: 50px;"> BETA</font>
      </sup> -->
    </p>
    <v-chart
      v-if="field === '@timestamp.keyword'"
      ref="options"
      :init-Options="initOptions"
      :options="options"
      :autoresize="true"
      :style="{ height, width }"
      @init="initChart"
    ></v-chart>
    <v-chart
      v-else
      ref="options"
      :init-Options="initOptions"
      :options="options"
      :autoresize="true"
      :style="{ height, width }"
      @init="initChart"
      @click="handleChartClick"
      @mouseover="ipLookup"
    ></v-chart>
  </div>
</template>

<script>
import ECharts from 'vue-echarts/components/ECharts'
import 'echarts/lib/chart/map'
import 'echarts/lib/component/visualMap'
import 'echarts/map/js/world'
import axios from 'axios'
import echarts from 'echarts'

export default {
  name: 'histogramBar',
  components: {
    'v-chart': ECharts
  },
  props: {
    text: {
      type: String
    },
    className: {
      type: String,
      default: 'chart'
    },
    user_index: {
      type: String
    },
    user_inst: {
      type: String
    },
    startTime: {
      type: [String, Number]
    },
    endTime: {
      type: [String, Number]
    },
    topLimit: {
      type: Number,
      default: 10
    },
    field: {
      type: String
    },
    orderby: {
      type: String,
      default: '_count'
    },
    fieldsum: {
      type: String,
      default: ''
    },
    interval: {
      type: String,
      default: '1h'
    },
    stores: {
      type: Array
    },
    subFilter: {
      type: String
    },
    valid: {
      type: Boolean
    },
    chartId: {
      type: String
    },
    chartName: {
      type: String,
      default: 'Untitle'
    },
    width: {
      type: [String, Number],
      default: '100%'
    },
    height: {
      type: [String, Number],
      default: '100%'
    },
    bar_line: {
      type: String,
      default: 'bar'
    },
    group: {
      type: String,
      default: null
    },
    editMode: {
      type: Boolean,
      default: false
    },
    slice: {
      type: [Object]
    },
    index_now: {
      type: String
    },
    previewMode: {
      type: Boolean,
      default: false
    },
    reloadchart: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      initOptions: { renderer: 'canvas' },
      x: [],
      y: [],
      options: {},
      newtime: '',
      time: '',
      times: '',
      intervals: '',
      sub: '',
      host: ''
    }
  },
  async created () {
    if (!this.user_index) {
      this.user_index = this.index_now
    }
  },
  async mounted () {
    await this.initChart()
    await this.beforeload()
  },
  methods: {
    async ipLookup (ip) {
      let response
      if (ip.name.match(/^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$/)) {
        response = await axios.post(apiUrl + '/api/status/nslookup', {
          ip: ip.name
        })
      }
      this.host = response.data.host
    },
    async initChart () {
      this.$refs.options.showLoading({
        color: '#4ea397',
        maskColor: 'transparent',
        textColor: '#ccc'
      })
      if (this.subFilter !== '*' && this.text !== '') {
        this.sub = ''
        this.sub = `${this.subFilter} AND ${this.text}`
      } else if (this.subFilter !== '*') {
        this.sub = ''
        this.sub = `${this.subFilter}`
      } else {
      }
      let options = {
        title: {
          show: true,
          text: this.chartName,
          textStyle: {
            color: '#ccc',
            fontFamily: 'Avenir, Helvetica, Arial, sans-serif'
          }
        },
        backgroundColor: 'transparent',
        series: []
      }
      if (this.field === '@timestamp.keyword') { // Date histogram aggregation
        let response = await axios.post(apiUrl + '/api/query/histogram', {
          start: this.startTime,
          end: this.endTime,
          instance: this.user_inst,
          index: this.user_index,
          interval: this.interval,
          group: this.group,
          stores: this.stores,
          sub: this.sub,
          text: this.text
        })
        this.$refs.options.hideLoading()
        // if (response.data.msg) {
        //   this.options = Object.assign({}, options, {
        //     graphic: {
        //       type: 'text',
        //       left: 'center',
        //       top: 'middle',
        //       style: {
        //         text: 'Request time out.',
        //         font: 'bolder 16px Avenir, Helvetica, Arial, sans-serif',
        //         fill: '#ccc'
        //       }
        //     }
        //   })
        //   return
        // }
        this.x = []
        this.y = []
        if (response.data.length) {
          // Still not work
          if (this.group) {
            // let j
            // for (i = 0; i < response.data.length; i++) {
            //   let date = ''
            //   let time = ''
            //   let formatTime = ''
            //   date = new Date(response.data[i].key).toDateString()
            //   time = new Date(response.data[i].key).toLocaleTimeString()
            //   formatTime = date + ' ' + time
            //   this.x.push(formatTime)
            //   this.y.push( [] )
            //   for (j = 0; j < response.data[i].group.buckets.length; j++) {
            //     let obj = {
            //       key: '',
            //       value: ''
            //     }
            //     obj.key = response.data[i].group.buckets[j].key
            //     obj.value = response.data[i].group.buckets[j].doc_count
            //     this.y[i].push(obj)
            //   }
            // }
            // this.options = {
            // title: {
            //   show: true,
            //   text: this.chartName,
            //   textStyle: {
            //     color: '#ccc',
            //     fontFamily: 'Avenir, Helvetica, Arial, sans-serif'
            //   }
            // },
            // grid: {
            //   top: 35,
            //   left: '5%',
            //   right: '5%',
            //   bottom: '3%',
            //   containLabel: true
            // },
            // toolbox: {
            //   show: true,
            //   orient: 'horizontal',
            //   itemSize: 18,
            //   itemGap: 20,
            //   right: 20,
            //   feature: {
            //     saveAsImage: {
            //       show: true,
            //       title: 'save as image'
            //     },
            //     dataView: {
            //       show: true,
            //       title: 'DataView',
            //       readOnly: true,
            //       lang: ['data view', 'turn off', 'refresh'],
            //       optionToContent: function (opt) {
            //         let axisData = opt.xAxis[0].data
            //         let series = opt.series
            //         let tdHeads = '<td  style="padding: 0 10px">Date</td>'
            //         let tdBodys = ''
            //         series.forEach(function (item) {
            //           tdHeads += `<td style="padding: 0 10px">${item.name}</td>`
            //         })
            //         let table = `<table border="1" style="width:100%;text-align:center"><tbody><tr>${tdHeads} </tr>`
            //         for (let i = 0, l = axisData.length; i < l; i++) {
            //           for (let j = 0; j < series.length; j++) {
            //             tdBodys += `<td>${series[j].data[i]}</td>`
            //           }
            //           table += `<tr><td style="padding: 0 10px">${axisData[i]}</td>${tdBodys}</tr>`
            //           tdBodys = ''
            //         }
            //         table += '</tbody></table>'
            //         return table
            //       }
            //     },
            //     magicType: {
            //       title: 'bar',
            //       type: [ 'line', 'bar' ]
            //     }
            //   }
            // },
            // xAxis: [{
            //   type: 'category',
            //   data: this.x,
            //   axisTick: {
            //     alignWithLabel: true
            //   },
            //   axisLine: {
            //     lineStyle: {
            //       color: 'white'
            //     }
            //   }
            // }],
            // yAxis: [{
            //   type: 'value',
            //   axisTick: {
            //     show: false
            //   },
            //   axisLine: {
            //     lineStyle: {
            //       color: 'white'
            //     }
            //   }
            // }],
            // series: [{
            //   name: 'count',
            //   type: this.bar_line,
            //   barWidth: '60%',
            //   data: this.y[0],
            //   },
            //   {
            //     name: 'count2',
            //     type: this.bar_line,
            //     barWidth: '60%',
            //     data: this.y[1]
            //   }]
            // }
          } else {
            for (let data of response.data) {
              let date = ''
              let time = ''
              let formatTime = ''
              date = new Date(data.key).toDateString()
              time = new Date(data.key).toLocaleTimeString()
              formatTime = date + ' ' + time
              this.x.push(formatTime)
              this.y.push(data.doc_count)
            }
            this.options = Object.assign({}, options, {
              grid: {
                top: 35,
                left: '5%',
                right: '5%',
                bottom: '3%',
                containLabel: true
              },
              // toolbox: {
              //   show: true,
              //   orient: 'horizontal',
              //   itemSize: 18,
              //   itemGap: 20,
              //   right: 20,
              //   feature: {
              //     saveAsImage: {
              //       show: true,
              //       title: 'save as image'
              //     }
              //   }
              // },
              xAxis: [{
                type: 'category',
                data: this.x,
                axisTick: {
                  alignWithLabel: true
                },
                axisLine: {
                  lineStyle: {
                    color: 'white'
                  }
                }
              }],
              yAxis: [{
                type: 'value',
                axisTick: {
                  show: false
                },
                axisLine: {
                  lineStyle: {
                    color: 'white'
                  }
                }
              }],
              series: [{
                name: 'count',
                type: this.bar_line,
                barWidth: '60%',
                data: this.y,
                itemStyle: {
                  normal: {
                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                      offset: 0,
                      color: '#83bff6'
                    }, {
                      offset: 0.5,
                      color: '#188df0'
                    }, {
                      offset: 1,
                      color: '#188df0'
                    }])
                  },
                  emphasis: {
                    label: {
                      show: true,
                      formatter: '{b}: {c}'
                    },
                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                      offset: 0,
                      color: '#2378f7'
                    }, {
                      offset: 0.7,
                      color: '#2378f7'
                    }, {
                      offset: 1,
                      color: '#83bff6'
                    }])
                  }
                }
              }]
            })
          }
        } else {
          this.options = Object.assign({}, options, {
            graphic: {
              type: 'text',
              left: 'center',
              top: 'middle',
              style: {
                text: 'No data',
                font: 'bolder 16px Avenir, Helvetica, Arial, sans-serif',
                fill: '#ccc'
              }
            }
          })
        }
      } else { // Terms aggregation
        let response = await axios.post(apiUrl + '/api/query/prop', {
          start: this.startTime,
          end: this.endTime,
          instance: this.user_inst,
          field: this.field,
          fieldsum: this.fieldsum,
          orderby: this.orderby,
          stores: this.stores,
          sub: this.sub,
          limit: this.topLimit,
          index: this.user_index,
          text: this.text
        })
        this.$refs.options.hideLoading()
        // if (response.data.msg) {
        //   this.options = Object.assign({}, options, {
        //     graphic: {
        //       type: 'text',
        //       left: 'center',
        //       top: 'middle',
        //       style: {
        //         text: 'Request time out.',
        //         font: 'bolder 16px Avenir, Helvetica, Arial, sans-serif',
        //         fill: '#ccc'
        //       }
        //     }
        //   })
        //   return
        // }
        this.x = []
        this.y = []
        if (response.data.length) {
          if (this.fieldsum) {
            for (let i = 0; i < response.data.length; i++) {
              this.x.push(response.data.map(a => a.sumbyte)[i].value)
              this.y.push(response.data[i].key)
            }
            this.options = Object.assign({}, options, {
              grid: {
                top: 35,
                left: '5%',
                right: '5%',
                bottom: '3%',
                containLabel: true
              },
              // toolbox: {
              //   show: true,
              //   orient: 'horizontal',
              //   itemSize: 18,
              //   itemGap: 20,
              //   right: 20,
              //   feature: {
              //     saveAsImage: {
              //       show: true,
              //       title: 'save as image'
              //     }
              //   }
              // },
              xAxis: [
                {
                  type: 'category',
                  data: this.y,
                  axisTick: {
                    alignWithLabel: true
                  },
                  axisLabel: {
                    rotate: 45
                  },
                  axisLine: {
                    lineStyle: {
                      color: 'white'
                    }
                  }
                }
              ],
              yAxis: [
                {
                  type: 'value',
                  axisLabel: {
                    formatter: function formatBytes (params) {
                        if (params === 0) return '0 Bytes'
                        const k = 1024
                        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
                        const i = Math.floor(Math.log(params) / Math.log(k))
                        return parseFloat((params / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i]
                    }
                  },
                  axisTick: {
                    show: true
                  },
                  axisLine: {
                    lineStyle: {
                      color: 'white'
                    }
                  }
                }
              ],
              series: [
                {
                  name: 'count',
                  type: this.bar_line,
                  barWidth: '60%',
                  data: this.x,
                  itemStyle: {
                    normal: {
                      color: new echarts.graphic.LinearGradient(
                        0, 0, 0, 1,
                        [{
                            offset: 0,
                            color: '#83bff6'
                          },
                          {
                            offset: 0.5,
                            color: '#188df0'
                          },
                          {
                            offset: 1,
                            color: '#188df0'
                          }
                        ]
                      )
                    },
                    emphasis: {
                      label: {
                        show: true,
                        formatter: function formatBytes (params) {
                            if (params.data === 0) return '0 Bytes'
                            const k = 1024
                            const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
                            const i = Math.floor(Math.log(params.data) / Math.log(k))
                            return parseFloat((params.data / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i]
                        }
                      },
                      color: new echarts.graphic.LinearGradient(
                        0, 0, 0, 1,
                        [
                          {
                            offset: 0,
                            color: '#2378f7'
                          },
                          {
                            offset: 0.7,
                            color: '#2378f7'
                          },
                          {
                            offset: 1,
                            color: '#83bff6'
                          }
                        ]
                      )
                    }
                  }
                }
              ]
            })
          } else {
            for (let data of response.data) {
              this.x.push(data.key)
              this.y.push(data.doc_count)
            }
            this.options = Object.assign({}, options, {
              grid: {
                top: 35,
                left: '5%',
                right: '5%',
                bottom: '3%',
                containLabel: true
              },
              // toolbox: {
              //   show: true,
              //   orient: 'horizontal',
              //   itemSize: 18,
              //   itemGap: 20,
              //   right: 20,
              //   feature: {
              //     saveAsImage: {
              //       show: true,
              //       title: 'save as image'
              //     }
              //   }
              // },
              xAxis: [{
                type: 'category',
                data: this.x,
                axisTick: {
                  alignWithLabel: true
                },
                axisLabel: {
                  rotate: 45
                },
                axisLine: {
                  lineStyle: {
                    color: 'white'
                  }
                }
              }],
              yAxis: [{
                type: 'value',
                axisTick: {
                  show: false
                },
                axisLine: {
                  lineStyle: {
                    color: 'white'
                  }
                }
              }],
              series: [{
                name: 'count',
                type: this.bar_line,
                barWidth: '60%',
                data: this.y,
                itemStyle: {
                  normal: {
                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                      offset: 0,
                      color: '#83bff6'
                    }, {
                      offset: 0.5,
                      color: '#188df0'
                    }, {
                      offset: 1,
                      color: '#188df0'
                    }])
                  },
                  emphasis: {
                    label: {
                      show: true,
                      formatter: '{b}: {c}'
                    },
                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                      offset: 0,
                      color: '#2378f7'
                    }, {
                      offset: 0.7,
                      color: '#2378f7'
                    }, {
                      offset: 1,
                      color: '#83bff6'
                    }])
                  }
                }
              }]
            })
          }
        } else {
          this.options = Object.assign({}, options, {
            graphic: {
              type: 'text',
              left: 'center',
              top: 'middle',
              style: {
                text: 'No data',
                font: 'bolder 16px Avenir, Helvetica, Arial, sans-serif',
                fill: '#ccc'
              }
            }
          })
        }
      }
    },
    beforeload () {
      this.$emit('loadChart', 'load', 'x-bar')
    },
    clickupdatetime () {
      if (this.time === '') {
      } else {
        this.newtime = this.time
        let cases = {
          'now-15m': {
            time: 10000,
            interval: '10s'
          },
          'now-30m': {
            time: 30000,
            interval: '10s'
          },
          'now-1h': {
            time: 60000,
            interval: '10s'
          },
          'now-12h': {
            time: 1800000,
            interval: '30s'
          },
          'now-1d': {
            time: 1800000,
            interval: '30s'
          },
          'now-7d': {
            time: 10800000,
            interval: '600s'
          },
          'now-1M': {
            time: 43200000,
            interval: '600s'
          }
        }
        this.times = this.time + cases[this.startTime].time
        this.intervals = cases[this.startTime].interval
        this.$emit('setTime', this.newtime, this.times, this.intervals)
      }
    },
    handleChartClick (param) {
      if (this.field === '@timestamp.keyword') {
        let startTime = Date.parse(param.name)
        let intervals = {
          '10s': 10 * 100,
          '30s': 30 * 100,
          '1m': 60 * 100,
          '10m': 10 * 60 * 100,
          '30m': 30 * 60 * 100,
          '3h': 3 * 60 * 60 * 100,
          '12h': 12 * 60 * 60 * 100
        }
        let endTime = startTime + intervals[this.interval]
        this.key = param.name
        this.$emit('setkey', startTime, endTime, this.key, this.field)
      } else {
        this.key = param.name
        this.$emit('setkey', this.startTime, this.endTime, this.key, this.field)
      }
    },
    deleteChart () {
      this.$emit('deleteChart', this.chartId)
    },
    duplicateChart () {
      this.$emit('duplicateChart', this.slice)
    },
    action () {
      this.$emit('actionToChart')
    }
  },
  watch: {
    startTime: {
      handler: function (startTime) {
        if (!this.user_index) {
          this.user_index = this.index_now
        }
        this.options = {}
        this.initChart()
      }
    },
    endTime: {
      handler: function (endTime) {
        if (!this.user_index) {
          this.user_index = this.index_now
        }
        this.options = {}
        this.initChart()
      }
    },
    stores: {
      handler: function (stores) {
        this.options = {}
        if (!this.user_index) {
          this.user_index = this.index_now
        }
        this.initChart()
      }
    },
    text: {
      handler: function (text) {
        if (!this.user_index) {
          this.user_index = this.index_now
        }
        this.options = {}
        this.initChart()
      }
    },
    user_index: {
      handler: function (user_index) {
        if (this.user_index) {
          this.options = {}
          this.initChart()
        }
      }
    },
    index_now: {
      handler: function (user_index) {
        this.user_index = this.index_now
      }
    },
    reloadchart: {
      handler: function (val) {
        this.options = {}
        this.initChart()
      }
    }
  }
}
</script>

<style scoped>
/* .chart {
  min-height: 250px
} */
</style>



// WEBPACK FOOTER //
// src/components/x-bar.vue